<ng-container *ngIf="mostraFiltroDisponibilita">



    <ng-container *ngIf="!mostraCaricamentoDisponibilitaUVM">
  
        <div>
            <strong>1 - Elenco attività disponibili</strong>
            <div>
                <mat-form-field>
                    <mat-label>Cerca attività</mat-label>
                    <input matInput (keyup)="applyFilter($event)"  #input>
                </mat-form-field>

                <table mat-table [dataSource]="dataSource">



                    <ng-container matColumnDef="descrizione">
                        <th mat-header-cell *matHeaderCellDef> Attività </th>
                        <td mat-cell *matCellDef="let element"> {{element.descrizione}}</td>
                    </ng-container>

                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef> </th>
                        <td mat-cell *matCellDef="let element"> <button mat-button
                                (click)="addToSelected(element)"><mat-icon aria-hidden="false"
                                    aria-label="Aggiungi icona" fontIcon="add"></mat-icon> Aggiungi</button> </td>
                    </ng-container>


                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="4">Nessun dato trovato per "{{input.value}}"</td>
                    </tr>


                </table>

                <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons
                    aria-label="Select page of periodic elements">
                </mat-paginator>
            </div>
        </div>

        <div>
            <strong>2 - Attività selezionata</strong>
            <button mat-button (click)="svuotaListaAttivita()"><mat-icon aria-hidden="false"
                    aria-label="Aggiungi icona" fontIcon="cancel"></mat-icon>Svuota lista</button>
            <table mat-table [dataSource]="dataSoruceSelected">




                <ng-container matColumnDef="descrizione">
                    <th mat-header-cell *matHeaderCellDef> Attività </th>
                    <td mat-cell *matCellDef="let element"> {{element.descrizione}}</td>
                </ng-container>


                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef> </th>
                    <td mat-cell *matCellDef="let element"> <button mat-button
                            (click)="rimuoviDaListaAttivitaSelezionate(element)"><mat-icon aria-hidden="false"
                                aria-label="Aggiungi icona" fontIcon="delete"></mat-icon> Rimuovi</button> </td>
                </ng-container>


                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                <tr class="mat-row " *matNoDataRow>
                    <td class="mat-cell no-results-row" [attr.colspan]="displayedColumns.length">
                        <div class="alert alert-warning " role="alert">
                            Nessuna attività selezionata.
                        </div>
                    </td>
                </tr>


            </table>


        </div>

    </ng-container>
    
    
    <button mat-flat-button (click)="saveAttivita()" class="mt-4" [disabled]="this.selectedAttivita.length == 0">
        <mat-icon>arrow_forward</mat-icon>Avanti
    </button>

</ng-container>




